package com.gsb.vyapar.bhagya.presentation.search.uistate

import com.gsb.vyapar.bhagya.domain.Business
import com.gsb.vyapar.bhagya.domain.Categories.D.Category
import com.gsb.vyapar.bhagya.domain.SubCategories.D.SubCategory
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.updateState

data class SearchUiState(
    val title: String = "Search",
    val queryString: String = "",
    val searchCategories: List<Category> = listOf(),
    val searchSubCategories: List<SubCategory> = listOf(),
    val searchBusinessList: List<Business> = listOf(),
) {
    fun updateQueryString(queryString: String) {
        updateSearchUiState(this.copy(queryString = queryString))
    }

    fun updateSearchCategories(searchCategories: List<Category>) {
        updateSearchUiState(this.copy(searchCategories = searchCategories))
    }

    fun updateSearchSubCategories(searchSubCategories: List<SubCategory>) {
        updateSearchUiState(this.copy(searchSubCategories = searchSubCategories))
    }

    fun updateSearchBusinessList(searchBusinessList: List<Business>) {
        updateSearchUiState(this.copy(searchBusinessList = searchBusinessList))
    }

    fun updateAllSearchUiState(queryString: String, searchCategories: List<Category>, searchSubCategories: List<SubCategory>, searchBusinessList: List<Business>) {
        updateSearchUiState(this.copy(queryString = queryString, searchCategories = searchCategories, searchSubCategories = searchSubCategories, searchBusinessList = searchBusinessList))
    }

    fun resetSearch() {
        updateSearchUiState(this.copy(queryString = "", searchCategories = listOf(), searchSubCategories = listOf(), searchBusinessList = listOf()))
    }
}

fun updateSearchUiState(searchUiState: SearchUiState) {
    updateState(getState().copy(searchUiState = searchUiState))
}

fun getSearchUiState(): SearchUiState {
    return getState().searchUiState
}
